import { render, staticRenderFns } from "./ParticipacionDataRegister.vue?vue&type=template&id=afe5521c&scoped=true"
import script from "./ParticipacionDataRegister.vue?vue&type=script&lang=js"
export * from "./ParticipacionDataRegister.vue?vue&type=script&lang=js"
import style0 from "./ParticipacionDataRegister.vue?vue&type=style&index=0&id=afe5521c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe5521c",
  null
  
)

export default component.exports